import React from 'react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-slate-800 bg-slate-950 px-5 py-10 text-white/85" data-id="element-62" data-mp="3geze367ujv27">
      <div className="mx-auto max-w-[720px] text-center text-[0.85rem] leading-relaxed" data-id="element-63" data-mp="32o4ao9g4a660">
        <p data-id="element-64" data-mp="36pfu1x8edv5r">
          © 2026 ANATOMY READY™ — All Rights Reserved. ANATOMY READY™ is an
          educational teaching resource. It does not replace school curriculum
          requirements, district standards, professional training,
          institutional policies, applicable educational regulations, or
          qualified teacher judgment.
        </p>
        <nav aria-label="Legal" className="mt-4" data-id="element-65" data-mp="3ldu4at858lwc">
          <ul className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1" data-id="element-66" data-mp="3qd6sbhar3z0i">
            {footerLinks.map((link, index) => <li key={link.label} className="flex items-center gap-2" data-id="element-67" data-mp="29ydw5zakp29d" data-mpi={index}>
                <a href={link.href} className="font-semibold text-white underline-offset-4 transition-colors duration-150 ease-out hover:text-orange-500 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500" data-id="element-68" data-mp="2eyt94pqy07qt">
                  {link.label}
                </a>
                {index < footerLinks.length - 1 && <span aria-hidden="true" className="text-white/40" data-id="element-69" data-mp="3q727ai5jt0b9">
                    •
                  </span>}
              </li>)}
          </ul>
        </nav>
      </div>
    </footer>;
}